import { collection, query, getDocs, doc, updateDoc, where, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const migrateReminderSettings = async (currentUser) => {
  try {
    console.log('Starting reminder settings migration...');
    
    // Get all disciples for the current user from their discipleIds array
    const userRef = doc(db, 'users', currentUser.uid);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      throw new Error('User document not found');
    }

    const discipleIds = userDoc.data().discipleIds || [];
    let migratedCount = 0;
    let errorCount = 0;

    for (const discipleId of discipleIds) {
      try {
        const mentorDetailsRef = doc(db, 'disciples', discipleId, 'mentorDetails', currentUser.uid);
        const mentorDetails = await getDoc(mentorDetailsRef);
        
        if (mentorDetails.exists()) {
          const data = mentorDetails.data();
          const currentSettings = data.reminderSettings || {};

          // Create new reminderSettings structure while preserving existing values
          const updatedSettings = {
            enabled: currentSettings.enabled ?? true,
            frequency: currentSettings.frequency ?? 7,
            preferredTime: currentSettings.preferredTime ?? "09:00",
            lastMessageDate: currentSettings.lastMessageDate ?? null,
            nextReminderDate: currentSettings.nextReminderDate ?? null,
            fcmToken: currentSettings.fcmToken ?? null,
            phoneNumber: data.phone ?? null,
            quietHours: {
              start: currentSettings.quietHours?.start ?? "22:00",
              end: currentSettings.quietHours?.end ?? "08:00"
            }
          };

          // Update the document with new structure
          await updateDoc(mentorDetailsRef, {
            reminderSettings: updatedSettings
          });

          migratedCount++;
          console.log(`Migrated settings for disciple: ${discipleId}`);
        }
      } catch (error) {
        errorCount++;
        console.error(`Error migrating disciple ${discipleId}:`, error);
      }
    }

    console.log(`Migration complete. Successfully migrated: ${migratedCount}, Errors: ${errorCount}`);
    return { success: true, migratedCount, errorCount };
  } catch (error) {
    console.error('Migration failed:', error);
    return { success: false, error: error.message };
  }
};
